import { Project } from '../../../../../../domain/project/Project';
import { FieldDefinition } from './FieldDefinitions';

const commonFields: FieldDefinition[] = [
  {
    id: `label`,
    type: `text`,
  },
];

// Id externo
// Dirección Línea 2
// Comentarios
// Email
// Persona de referencia
// Teléfono
// Sitio web
// Crear campo personalizado

export const getStopFields = (project: Project) => {
  const clientFields = [...commonFields];
  const enabledFields = project.view.client;
  const constraintFields = project.view.constraints;
  const customFields = project.custom_fields?.client || [];

  if (enabledFields.external_id) {
    clientFields.push({
      id: `external_id`,
      type: `text`,
    });
  }
  if (enabledFields.location_details) {
    clientFields.push({
      id: `location_details`,
      type: `text`,
    });
  }
  if (enabledFields.comments) {
    clientFields.push({
      id: `comments`,
      type: `text`,
    });
  }
  if (enabledFields.email) {
    clientFields.push({
      id: `email`,
      type: `text`,
    });
  }
  if (enabledFields.reference_person) {
    clientFields.push({
      id: `reference_person`,
      type: `text`,
    });
  }
  if (enabledFields.phone) {
    clientFields.push({
      id: `phone`,
      type: `text`,
    });
  }
  if (enabledFields.url) {
    clientFields.push({
      id: `url`,
      type: `text`,
    });
  }
  clientFields.push({
    id: `duration`,
    type: `time_minutes`,
  });

  // take
  // Peso
  // Volumen
  // Ventanas horarias
  // Provee/Requiere
  // Paradas máximas
  // Recogida
  // Zonas
  // Distancia máxima
  // Tiempo máximo
  // Tiempo máximo de reparto
  // Recompensa
  // Cluster

  if (constraintFields.weight) {
    clientFields.push({
      id: `weight`,
      type: `numerical`,
    });
  }
  if (constraintFields.volume) {
    clientFields.push({
      id: `volume`,
      type: `numerical`,
    });
  }
  if (constraintFields.time_windows) {
    clientFields.push({
      id: `time_windows`,
      type: `time_window`,
      multiple: true,
    });
  }
  if (constraintFields.provide_requires) {
    clientFields.push({
      id: `requires`,
      type: `list`,
    });
  }
  // if (constraintFields.geo_fences) {
  //   clientFields.push({
  //     id: `geo_fences`,
  //     type: `list`,
  //     // label: `Zones`,
  //     options: project.geo_fences?.map((fence) => fence.label) || [],
  //   });
  // }

  clientFields.push({
    id: `client_external_id`,
    type: `text`,
  });
  if (constraintFields.reward) {
    clientFields.push({
      id: `reward`,
      type: `numerical`,
    });
  }
  if (constraintFields.cluster) {
    clientFields.push({
      id: `cluster`,
      type: `list`,
    });
  }

  customFields.forEach((field) => {
    if (field.enabled) {
      if (field.field_type === `categorical`) {
        clientFields.push({
          id: field.custom_id,
          type: field.field_type,
          label: field.label,
          options: field.options as string[],
          isMultipleChoice: field.multiple || false,
          isCustomField: true,
        });
      } else if (field.field_type === `numerical`) {
        clientFields.push({
          id: field.custom_id,
          type: field.field_type,
          label: field.label,
          isCustomField: true,
        });
      } else if (field.field_type === `text`) {
        clientFields.push({
          id: field.custom_id,
          type: field.field_type,
          label: field.label,
          isCustomField: true,
        });
      } else if (field.field_type === `boolean`) {
        clientFields.push({
          id: field.custom_id,
          type: field.field_type,
          label: field.label,
          isCustomField: true,
        });
      }
    }
  });

  return clientFields;
};
